// Sorts games most-recent-first: primarily by datePlayed (the day the game
// actually happened), falling back to dateSaved (a precise timestamp, set
// on every game since the app's first version) only to break a tie between
// games played on the same day -- datePlayed alone is just a YYYY-MM-DD
// string, so two games saved on the same day would otherwise tie with no
// defined order.
export function compareGames(a, b) {
  const dayCompare = (b.datePlayed ?? '').localeCompare(a.datePlayed ?? '');
  if (dayCompare !== 0) return dayCompare;
  return (b.dateSaved?.toMillis?.() ?? 0) - (a.dateSaved?.toMillis?.() ?? 0);
}
